export const FREQUENTLY_USED_KEY = 'frequently_used';
export const FREQUENTLY_USED_EMOJIS_STORAGE_KEY = 'frequently_used_emojis';

export const EMOJI_THUMBS_UP = 'thumbsup';
export const EMOJI_THUMBS_DOWN = 'thumbsdown';

export const CATEGORY_NAMES = [
  FREQUENTLY_USED_KEY,
  'custom',
  'people',
  'activity',
  'nature',
  'food',
  'travel',
  'objects',
  'symbols',
  'flags',
];
export const CATEGORY_ICON_MAP = {
  [FREQUENTLY_USED_KEY]: 'history',
  custom: 'tanuki',
  activity: 'dumbbell',
  people: 'smiley',
  nature: 'nature',
  food: 'food',
  travel: 'car',
  objects: 'object',
  symbols: 'heart',
  flags: 'flag',
};

export const EMOJIS_PER_ROW = 9;
export const EMOJI_ROW_HEIGHT = 34;
export const CATEGORY_ROW_HEIGHT = 37;

export const CACHE_VERSION_KEY = 'gl-emoji-map-version';
export const CACHE_KEY = 'gl-emoji-map';

export const NEUTRAL_INTENT_MULTIPLIER = 1;
